﻿export class UTMClass{
    id:number = 0;
    order_master_id:string='';
    utm_campaign:string='';
    utm_medium:string='';
    utm_source:string='';
    utm_content:string='';
}